import React, { useState } from 'react';
import { formatDate } from '../utils/formatDate';
import { useAuth } from '../contexts/AuthContext';
import { STORAGE_KEYS } from '../constants/storageKeys';

const STATUS_LABEL: Record<string, string> = {
  trialing: 'Free trial',
  active: 'Active',
  past_due: 'Payment past due',
  canceled: 'Canceled',
};

// Account-level billing card — one subscription covers every workspace
// (project) this account manages, so this lives in Account settings, not
// per-workspace settings.
const BillingSettingsCard: React.FC = () => {
  const { subscription } = useAuth();
  const [redirecting, setRedirecting] = useState(false);

  const handleUpgrade = async () => {
    setRedirecting(true);
    try {
      const guestguruToken = localStorage.getItem(STORAGE_KEYS.GG_AUTH_TOKEN);
      const apiKey = import.meta.env.VITE_ANS_WEB_API_KEY || '';
      const baseUrl = process.env.REACT_APP_GG_API_URL || 'http://localhost:3000';
      const response = await fetch(`${baseUrl}/billing/checkout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiKey,
          Authorization: `Bearer ${guestguruToken}`,
        },
        body: JSON.stringify({ callback_url: window.location.href }),
      });
      const data = await response.json();
      if (data.authorization_url) {
        window.location.href = data.authorization_url;
      } else {
        setRedirecting(false);
      }
    } catch {
      setRedirecting(false);
    }
  };

  return (
    <div className="settings-card">
      <h4 className="settings-card-title">Billing</h4>
      {!subscription ? (
        <p className="settings-auth-note">Loading billing status…</p>
      ) : (
        <>
          <p className="settings-auth-note">
            Plan: <strong>{subscription.plan}</strong> · Status: <strong>{STATUS_LABEL[subscription.status] ?? subscription.status}</strong>
            {subscription.status === 'trialing' && subscription.trial_ends_at && (
              <> · Trial ends {formatDate(subscription.trial_ends_at)}</>
            )}
          </p>
          {subscription.status !== 'active' && (
            <button className="primary-btn" onClick={handleUpgrade} disabled={redirecting}>
              {redirecting ? 'Redirecting…' : 'Upgrade / Manage billing'}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default BillingSettingsCard;
